import React from 'react';
import PropTypes from 'prop-types';
import Table from '../Table/Table.jsx';
import TableCell from '../Table/TableCell.jsx';
import TableHead from '../Table/TableHead.jsx';
import TableHeader from '../Table/TableHeader.jsx';
import TableRow from '../Table/TableRow.jsx';
import ReservationStatusLabel from './ReservationStatusLabel.jsx';
import UpsellStatusLabel from './UpsellStatusLabel.jsx';
import PreArrivalInteractionLabel from './PreArrivalInteractionLabel.jsx';
import {colors} from '../../utils/colors.js';
import {formatCurrency} from '../../utils/formatCurrency.js';

const ReservationProfileStatus = ({
  reservationProfile,
  upsellTotal,
}) => {
  const hasPreArrivalInteraction = !!reservationProfile.preArrivalInteraction;
  const totalAmount = upsellTotal?.total ?? 0;
  const totalCurrency = upsellTotal?.currency ?? reservationProfile.upsellSummary?.currency ?? 'EUR';

  return (
    <Table cellAlign="center" style={{marginBottom: 20}}>
      <TableHead>
        <TableHeader>Res. Status</TableHeader>
        <TableHeader>Res. ID</TableHeader>
        <TableHeader>Language</TableHeader>
        <TableHeader>Upsell Status</TableHeader>
        <TableHeader>Total</TableHeader>
        {hasPreArrivalInteraction &&
          <TableHeader>Pre-Arrival Interaction</TableHeader>
        }
      </TableHead>
      <tbody>
        <TableRow>
          <TableCell>
            <ReservationStatusLabel status={reservationProfile.reservationStatus} />
          </TableCell>
          <TableCell>{reservationProfile.channelReference}</TableCell>
          <TableCell>{reservationProfile.guest?.language || '-'}</TableCell>
          <TableCell>
            <UpsellStatusLabel
              status={reservationProfile.status}
              upsellingBlocker={reservationProfile.upsellingBlocker}
            />
          </TableCell>
          {totalAmount > 0 ?
            <TableCell style={{backgroundColor: colors.success10, color: colors.success}}>
              {formatCurrency(totalAmount, totalCurrency)}
            </TableCell>
          :
            <TableCell>-</TableCell>
          }
          {hasPreArrivalInteraction &&
            <TableCell>
              <PreArrivalInteractionLabel
                preArrivalInteraction={reservationProfile.preArrivalInteraction}
                abandonedCart={reservationProfile.abandonedCart}
                reservation={reservationProfile}
              />
            </TableCell>
          }
        </TableRow>
      </tbody>
    </Table>
  );
};

ReservationProfileStatus.propTypes = {
  reservationProfile: PropTypes.shape({
    reservationStatus: PropTypes.string,
    status: PropTypes.string,
    channelReference: PropTypes.string,
    upsellingBlocker: PropTypes.string,
    preArrivalInteraction: PropTypes.string,
    abandonedCart: PropTypes.object,
    upsellSummary: PropTypes.shape({
      currency: PropTypes.string,
    }),
    guest: PropTypes.shape({
      language: PropTypes.string,
    }),
  }).isRequired,
  upsellTotal: PropTypes.shape({
    total: PropTypes.number,
    currency: PropTypes.string,
  }),
};

export default ReservationProfileStatus;
